import { CurrentActionTypes } from "@/shared/atoms/usePosOrderCurrentAction";
import PosMenuBottomActionButton, {
  PosMenuAction,
} from "../PosMenu/PosMenuBottomActionButton";
import { useSetModal } from "@/shared/atoms/useModal";
import { useTranslation } from "react-i18next";

const useNewOrderAction = (): PosMenuAction => {
  const setModal = useSetModal();
  const { t } = useTranslation("");

  return {
    name: "newOrder" as CurrentActionTypes,
    label: t("resetSelectDelivery"),
    set: setModal,
    instantSet: true,
    filtered: false,
    disabled: false,
    iconVariant: "plus",
    variant: "primary",
  };
};

const NewOrderAction = () => {
  const action = useNewOrderAction();

  return (
    <PosMenuBottomActionButton
      action={action}
      isSelected={true}
      onClick={() => {
        action.set("posDeliveryMethod");
      }}
    />
  );
};

export default NewOrderAction;
